import { useMutation, useQuery } from 'react-query'
import httpClient from '~/utils/httpClient'

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await httpClient.post<{ data: boolean }>('/api/auth/forgot-password', {
        email,
      })
      return response?.data.data
    },
  })
}

export const useCheckResetTokenQuery = (token: string | null) => {
  return useQuery({
    queryKey: ['reset-token', token],
    queryFn: async () => {
      if (!token) throw new Error('Token is required')
      const response = await httpClient.get<{ data: { expiryTs: Date } }>(
        `/api/auth/reset-password?token=${token}`,
      )
      return response?.data.data
    },
    enabled: !!token,
    retry: false,
  })
}

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: async (data: { token: string | null; password: string }) => {
      const response = await httpClient.post<{ data: boolean }>('/api/auth/reset-password', data)
      return response?.data.data
    },
  })
}
